export default {
    firstGivenName: {
        formProp: 'firstGivenName',
        form: {
            label: 'First / Given Name',
            required: true,
            help: ''
        },
        field: {
            size: 'small',
            placeholder: 'First / Given Name',
            value: ''
        },
        validation: [ 
            'min-length:1', 
            'regex:^[a-zA-Z\\s,-.\'\`]*$:Only English alphabetic, spaces and some special characters (i.e ,-.\'\`).' 
        ]
    },
    middleName: {
        formProp: 'middleName',
        form: {
            label: 'Middle Name',
            required: false,
            help: ''
        },
        field: {
            size: 'small',
            placeholder: 'Middle Name',
            value: ''
        }
    },
    lastFamilySurname: {
        formProp: 'lastFamilySurname',
        form: {
            label: 'Last / Family / Surname',
            required: true,
            help: ''
        },
        field: {
            size: 'small',
            placeholder: 'Last / Family / Surname',
            value: ''
        },
        validation: [ 
            'min-length:1', 
            'regex:^[a-zA-Z\\s,-.\'\`]*$:Only English alphabetic, spaces and some special characters (i.e ,-.\'\`).' 
        ]
    }
}
